/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAPFSPDetails
 */
export interface IAPFSPDetails {
    /**
     * 
     * @type {number}
     * @memberof IAPFSPDetails
     */
    fspNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof IAPFSPDetails
     */
    fspName?: string;
}

/**
 * Check if a given object implements the IAPFSPDetails interface.
 */
export function instanceOfIAPFSPDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IAPFSPDetailsFromJSON(json: any): IAPFSPDetails {
    return IAPFSPDetailsFromJSONTyped(json, false);
}

export function IAPFSPDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPFSPDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fspNumber': !exists(json, 'FspNumber') ? undefined : json['FspNumber'],
        'fspName': !exists(json, 'FspName') ? undefined : json['FspName'],
    };
}

export function IAPFSPDetailsToJSON(value?: IAPFSPDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FspNumber': value.fspNumber,
        'FspName': value.fspName,
    };
}

